import { h, FunctionalComponent } from 'preact';
import { connect } from 'preact-redux';
import { CounterState } from '../../store/counter/types';

interface Props {
    name: string;
    words: boolean;
};

type AllProps = Props & CounterState;

export const CounterSFC: FunctionalComponent<AllProps> = ({name,words,counters}) => {
    return counters[name] !== undefined
        ? <span>{counters[name].toLocaleString('en-US')}{words ? (counters[name] !== 1 ? ' times' : ' time') : ''}</span>
        : <span>{words ? 'some number of times' : '0'}</span>;;
};

import { ApplicationState } from '../../store';
const mapStateToProps = (state: ApplicationState) => state.counter;

export default connect(mapStateToProps)(CounterSFC);



// WEBPACK FOOTER //
// ./components/counter/index.tsx